export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly codigo: string | null = null,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Llama a la API de Express. En desarrollo Vite hace proxy de `/api` al
 * servidor local (ver vite.config.ts); en produccion comparten dominio.
 * Devuelve el cuerpo JSON ya parseado.
 */
export async function api<T>(
  path: string,
  init?: RequestInit,
  token?: string,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init?.headers as Record<string, string> | undefined),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  let res: Response;
  try {
    res = await fetch(`/api${path}`, { ...init, headers });
  } catch {
    throw new ApiError(0, 'No hay conexión con el servidor');
  }

  const texto = await res.text();
  const cuerpo = texto ? (JSON.parse(texto) as unknown) : null;

  if (!res.ok) {
    const detalle = cuerpo as { error?: string; codigo?: string | null } | null;
    throw new ApiError(
      res.status,
      detalle?.error ?? `Error ${res.status}`,
      detalle?.codigo ?? null,
    );
  }

  return cuerpo as T;
}
